module.exports = __webpack_public_path__ + "media/images/svg-sprite-items/payment/payment-on-invoice-pl-d01a5a803f3dddb66cb1a8cae0488f32.svg";